import { Component } from "react";
import Glob from "../../libs/Glob.mjs";
import "./PeriGantt.css";
import ChevronLeftIcon from "../../media/images/ChevronLeftIcon.mjs";
import ChevronRightIcon from "../../media/images/ChevronRightIcon.mjs";
import CloseIcon from "../../media/images/CloseIcon.mjs";
import AppInfoIcon from "../../media/app-images/AppInfoIcon.mjs";
import PropTypes from "prop-types";
import appLib from "../../libs/appLib.mjs";
import PeriGanttNodeInfo from "./PeriGanttNodeInfo.mjs";

const prefix = "PeriGantt";


const PeriGantt = class extends Component {
	static propTypes = {
		/**
		 * @desc ID of the perimeter
		 * @desc Mandatory if "source" data is missing
		 * @type {string}
		 */
		id: PropTypes.string,
		/**
		 * @desc Raw data of the strategic cycle
		 * @type {Object}
		 */
		rawData: PropTypes.object,
		triggers: PropTypes.arrayOf(PropTypes.string),
		simul: PropTypes.string,
		all: PropTypes.object,
	};
	constructor(props) {
		super(props);
		this.state = {
			ll: Glob.getLanguageLong()
		};
		this.autoLoad = this.autoLoad.bind(this);
		this.getItem = this.getItem.bind(this);
		this.getName = this.getName.bind(this);
		this.getType = this.getType.bind(this);
		this.gantt = this.gantt.bind(this);
		this.uid = Glob.generateUid(prefix);
		this.info = this.info.bind(this);
		this.customInfo = this.customInfo.bind(this);
		this.toggleInfo = this.toggleInfo.bind(this);
		this.openNodeInfo = this.openNodeInfo.bind(this);
		this.addNodeInfo = this.addNodeInfo.bind(this);
		//console.log( props.all );
	}
	getItem( itemID ) {
		return (this.props.stepData.items||[]).find( item => item.id === itemID );
	}
	getName( id ) {
		return this.props.all[id]?.name;
	}
	getType( id ) {
		return this.props.all[id]?.type;
	}
	autoLoad() {
		const ns = {
			curDelay: this.props.stepData.curTime || this.props.stepData.delay || 0,
			falling: []
		};
		const items = this.props.stepData.items||[];
		ns.falling = items.filter( item => (item.falling) );
		ns.falling.filter( item => item.delay ).forEach( item => {
			if ( item.delay > ns.curDelay ) ns.curDelay = item.delay;
		});
		const timeSteps = [0];
		ns.falling
			.sort( (a,b) => this.getName(a.id).toLocaleLowerCase(this.state.ll).localeCompare(this.getName(b.id).toLocaleLowerCase(this.state.ll)))
			.sort( (a, b) => ((b.delay||0) - (a.delay||0)) ) ;
		// ns.falling.sort( (a,b) => {
		// 	const x = ((a.history && a.history[0]) ? a.history[0].start : a.delay) || 0;
		// 	const y = ((b.history && b.history[0]) ? b.history[0].start : b.delay) || 0;
		// 	if ( x === y ) return this.getName(a.id).toLocaleLowerCase(this.state.ll).localeCompare(this.getName(b.id).toLocaleLowerCase(this.state.ll));
		// 	return ( y - x);
		// });
		ns.falling.forEach( item => {
			item.position = Math.min(Math.round(8000 * (item.delay || 0) / (ns.curDelay || 1 )) / 100, 80);
			item.final =  80 - Math.min(Math.round(8000 * (item.end || ns.curDelay || 1) / (ns.curDelay || 1 )) / 100, 80);
			if ( item.end) {
				item.width = Math.round( 8000 * ((item.end - (item.delay||0))/ns.curDelay))/100;
			} else {
				item.width = 100 - item.position;
			}
			item.value = 100 - (Math.round(10000 * (item.status.o || 0) ) / 100);
			if ( item.delay && ! timeSteps.includes(item.delay)) timeSteps.push(item.delay);
			if ( item.history ) {
				item.history.forEach( ih => {
					if ( ih.start && ! timeSteps.includes(ih.start)) timeSteps.push(ih.start);
					ih.position = Math.min(Math.round(8000 * (ih.start || 0) / (ns.curDelay || 1 )) / 100, 80);
					if ( ih.end ) {
						ih.width = Math.round( 8000 * ((ih.end - (item.start||0))/ns.curDelay))/100;
						ih.final =  80 - (Math.round(8000 * (ih.end) / (ns.curDelay || 1 )) / 100);
					} else {
						ih.width = 100 - ih.position;
					}
					ih.value = 100 - (Math.round(10000 * (ih.status.o || 0) ) / 100);
				});
			}
		});
		timeSteps.sort( (a,b) => ( a - b));
		ns.timeSteps = timeSteps.map( s => {
			if ( ! s ) return null;
			const o = { delay: s };
			o.position = Math.min(Math.round(8000 * (s || 0) / (ns.curDelay || 1 )) / 100, 80);
			return o;
		}).filter(s => !! s).filter( (s,idx, all) => {
			if ( ! idx ) return true;
			return ( s.position - all[idx -1].position > 3 );
		});
		this.setState(ns);
	}
	componentDidMount() {
		this.autoLoad();
	}
	customRender() {
		return (
			<>
				{(typeof this.props.nav?.canPrevious === 'function' && this.props.nav?.canPrevious()) && (
					<div className={"stepNav previous"} onClick={ this.props.nav.gotoPrevious }>
						<ChevronLeftIcon />
					</div>
				)}
				{(typeof this.props.nav?.canNext === 'function' && this.props.nav?.canNext()) && (
					<div className={"stepNav next"} onClick={ this.props.nav.gotoNext }>
						<ChevronRightIcon />
					</div>
				)}
			</>
		)
	}
	info() {
		return (
			<div
				className={"info"}
				onClick={ (e) => { e.stopPropagation() } }
			>
				{ this.customInfo() }
				<h4 onClick={ this.toggleInfo }>
					<div>
						<AppInfoIcon />
						<span>Legenda della rappresentazione del Gantt</span>
					</div>
					<span>
						<CloseIcon />
					</span>
				</h4>
				<p>Le informazioni riportate sono molteplici, e sono così rappresentate…</p>
			</div>
		)
	}
	customInfo() {
		return null;
	}
	toggleInfo() {
		this.setState({ showInfo: !this.state.showInfo });
	}
	showDelay( d ) {
		return appLib.min2str(d);
	}
	gantt() {
		if ( ! this.state.falling || ! this.state.falling.length ) return null;
		return(
			<div className={"gantt"}>
				<div className={"cage"}>
					<div className={"grid"}>
						{ this.state.timeSteps.map( (s,idx) => (
							<div key={idx} style={{left:`${s.position}%`}} />
						))}
					</div>
					<div className={"top"}>
						<div className={"line"}>
							<div className={"area"}>
								{ this.state.timeSteps.map( (s,idx) => (
									<div key={idx} style={{left:`${s.position}%`}}>
										{ this.showDelay(s.delay) }
									</div>
								))}
							</div>
						</div>
					</div>
					<div className={"content"}>
						{ this.state.falling.map( item => (
							<div className={"line"} key={item.id}>
								<div className={"area"}>
									{ (item.history||[item]).map( (s,idx) => (
										<div
											style={{ left:`${s.position}%`,width:`${s.width}%` }}
											key={ idx }
											title={ (s.delay || s.start) ? 'Delay: '+this.showDelay( s.delay || s.start ) : undefined }
											onClick={ e => {
												e.stopPropagation();
												//this.openNodeInfo(s,item);
												this.openNodeInfo(item);
											}}
										>
											<span>
												{s.value ? `${s.value}%` : '—'}
											</span>
											<div style={{height:`${s.value}%`}}/>
										</div>
									))}
								</div>
								<h4>
									<strong>
										{ this.getName(item.id) }
									</strong>
									<em>
										{ this.getType(item.id) }
									</em>
								</h4>
							</div>
						))}
					</div>
				</div>
			</div>
		)
	}
	openNodeInfo(item4info) {
		const item = structuredClone(item4info);
		const x = (this.state.infoForNode || []).filter( i => i.id !== item.id);
		if ( ! Array.isArray(item.history) || ! item.history.length ) item.history = [structuredClone(item)];
		if ( ! item.label) item.label = this.getName( item.id );
		item.history.forEach( he => {
			if ( he.by ) he.byLabel = this.getName( he.by );
			if ( ! he.delay ) he.delay = he.start || 0;
			if ( ! he.delayLabel ) he.delayLabel = this.showDelay(he.delay ?? he.start);
		});
		x.push( item );
		this.setState({ infoForNode: x });
	}
	addNodeInfo(itemID) {
		const item = this.state.falling.find( i => i.id === itemID );
		if ( item ) setTimeout( ()=> { this.openNodeInfo(item) },100);
	}
	nodeInfo( id, node, idx ) {
		return(
			<PeriGanttNodeInfo
				key={ `${Date.now()}-${id}` }
				index={ idx }
				node={ node }
				peri={ this.props.id }
				another={ id => { this.addNodeInfo(id) }}
				close={ ()=>{
					const i = (this.state.infoForNode || []).filter( i => i.id !== id);
					this.setState({ infoForNode: i });
				}}
			/>
		)
	}
	render() {
		return (
			<div className={prefix+'Container'}>
				<div className={prefix} id={this.uid} />
				<div
					className={prefix+'Info '+(this.state.showInfo?'expanded':'collapsed')}
					onClick={ this.toggleInfo }
				>
					<span className={'toggler'}>
						<AppInfoIcon />
					</span>
					{ this.info() }
				</div>
				{ this.customRender() }
				{ (!!this.state.infoForNode) && ( this.state.infoForNode.length > 0) && (
					this.state.infoForNode.map( (step, idx ) => this.nodeInfo(step.id, step, idx) )
				)}
				{ this.gantt() }
			</div>
		)
	}
}

export default PeriGantt;